
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.03659 11.9936C5.84132 11.7983 5.84132 11.4817 6.03658 11.2865L8.13299 9.19L6.03658 7.09354C5.84132 6.89827 5.84132 6.58169 6.03659 6.38643C6.23185 6.19117 6.54843 6.19118 6.74369 6.38644L8.84009 8.48289L10.9365 6.38644C11.1317 6.19118 11.4483 6.19117 11.6436 6.38643C11.8389 6.58169 11.8389 6.89827 11.6436 7.09354L9.54719 9.19L11.6436 11.2865C11.8389 11.4817 11.8389 11.7983 11.6436 11.9936C11.4483 12.1888 11.1317 12.1888 10.9365 11.9936L8.84009 9.89712L6.74369 11.9936C6.54843 12.1888 6.23185 12.1888 6.03659 11.9936Z","fill":"#808080"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.589844 9.18994C0.589844 13.7463 4.28349 17.4399 8.83984 17.4399C13.3962 17.4399 17.0898 13.7463 17.0898 9.18994C17.0898 4.63359 13.3962 0.939941 8.83984 0.939941C4.28349 0.939941 0.589844 4.63359 0.589844 9.18994ZM8.83984 16.4399C4.83578 16.4399 1.58984 13.194 1.58984 9.18994C1.58984 5.18588 4.83578 1.93994 8.83984 1.93994C12.8439 1.93994 16.0898 5.18588 16.0898 9.18994C16.0898 13.194 12.8439 16.4399 8.83984 16.4399Z","fill":"#808080"}})])
          )
        }
      }
    